var _circle, _circle2, _circle3, _circle4, _g, _path, _path2, _circle5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrivateclub(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 51.9811,
    cy: 51.9811,
    r: 51.9811,
    fill: "#314DD8"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 51.9811,
    cy: 51.9811,
    r: 51.9811,
    fill: "#22FFAA"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.548,
    cy: 48.6024,
    r: 33.3478,
    fill: "#00E98F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_248_28798",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 104,
    height: 104
  }, _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 51.9811,
    cy: 51.9811,
    r: 51.9811,
    fill: "#22FFAA"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_248_28798)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.939 38.1937H68.5123V81.9336H43.7256L35.07 92.9671L31.3323 81.9336H18.939V38.1937Z",
    fill: "#243CBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2804 33.5563C16.3361 33.5563 13.8667 36.0257 13.8667 38.97V81.4171C13.8667 84.3687 16.3288 86.8308 19.2804 86.8308H29.0118V100.683C29.0118 101.947 29.8081 103.064 30.999 103.481C32.1898 103.897 33.5122 103.517 34.3012 102.531L46.8673 86.8235H67.3311C70.2826 86.8235 72.752 84.3614 72.752 81.4098V72.7523H66.8124V80.8911H45.4427C44.5441 80.8911 43.6893 81.3002 43.1267 82.0089L34.9515 92.2225V83.8646C34.9515 82.2281 33.6218 80.8984 31.9853 80.8984H19.8064V39.496H66.8197V73.4286H72.752V38.97C72.752 36.0184 70.2826 33.5563 67.3311 33.5563H19.2804Z",
    fill: "#243CBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0557 33.2825H67.2578C70.3213 33.2825 72.8049 35.766 72.8049 38.8295V66.9114H36.0557V33.2825Z",
    fill: "#060C23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.847 0.694569C71.9777 0.723793 71.1594 1.12562 70.6188 1.81237L58.0527 17.5127H37.5816C34.63 17.5127 32.168 19.9821 32.168 22.9336V48.9884H38.1076V23.4524H59.4773C60.3832 23.4524 61.2307 23.0432 61.8006 22.3346L69.9758 12.121V20.4862C69.9758 22.1227 71.3055 23.4524 72.942 23.4524H85.1209V64.8547H38.1003V41.7463H32.1606V65.3735C32.1606 68.325 34.63 70.7871 37.5743 70.7871H85.6323C88.5766 70.7871 91.046 68.325 91.046 65.3735V22.9263C91.046 19.9748 88.5839 17.5054 85.6323 17.5054H75.9009V3.66075C75.9009 2.85711 75.5794 2.08999 75.0023 1.52744C74.4251 0.964886 73.6507 0.672652 72.847 0.694569Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9466 41.9468C57.7199 41.9468 59.9733 44.173 59.9733 46.913C59.9733 48.7968 58.9002 50.5092 57.1917 51.3573V55.3287C57.1917 56.5601 56.1929 57.5468 54.9466 57.5468C53.7002 57.5468 52.7015 56.5519 52.7015 55.3287V51.3492C51.0012 50.5092 49.9282 48.7886 49.9199 46.913C49.9199 44.1649 52.1733 41.9468 54.9466 41.9468Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.7285 95.7531C71.0013 94.3482 74.936 92.3878 78.4788 89.9783C80.0237 88.9276 81.4941 87.7914 82.8856 86.5787",
    stroke: "white",
    strokeWidth: 2.08014,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.253 25.2563C22.0483 16.9529 31.5297 11.1982 42.0209 9.00189M54.0209 8.07781C51.9831 7.97027 49.9586 7.99746 47.958 8.15299",
    stroke: "white",
    strokeWidth: 2.08014,
    strokeLinecap: "round"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 54.9499,
    cy: 46.9763,
    r: 2.59982,
    fill: "#060C23"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivateclub);
export default __webpack_public_path__ + "static/media/private club.597c571e45a94f6f2b814b7a1c8a0ffd.svg";
export { ForwardRef as ReactComponent };